// src/pages/product/product.styled.ts
import styled from 'styled-components';

export const ProductSearchCard = styled.div`
  padding: 1rem;
  background: var(--surface-2);
  border-radius: 4px;
  margin-bottom: 1rem;
`;

// Garante que o container ocupe toda a largura interna disponível
export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--text);
  border-radius: 4px;
  box-shadow: var(--shadow);
  margin-bottom: 1rem;

  /* Remova qualquer padding extra, se houver */
  padding: 0;
`;

// Faz a <table> 100% da largura do container
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: var(--text);

  th, td {
    border: 1px solid var(--border);
    padding: 8px;
  }

  th {
    background: var(--surface-2);
    color: var(--text-muted);
    text-align: left;
  }

  tr:hover {
    background: rgba(43, 123, 255, 0.1);
  }
`;
